import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";
import { getGdpr } from "@/i18n/gdpr";

export const CookieConsent = () => {
  const { lang } = useI18n();
  const g = getGdpr(lang);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("va_consent")) setVisible(true);
  }, []);

  const choose = (choice) => {
    localStorage.setItem("va_consent", choice);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent"
      className="fixed bottom-0 inset-x-0 z-[70] bg-black/95 backdrop-blur-xl border-t border-theatre-gold/30 px-6 py-5"
    >
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row md:items-center gap-4 justify-between">
        <div className="flex items-start gap-3">
          <Cookie className="text-theatre-gold shrink-0 mt-0.5" size={20} />
          <p className="text-sm text-neutral-300 leading-relaxed max-w-3xl">
            {g.consentText}{" "}
            <Link to="/confidentialite" data-testid="consent-privacy-link" className="text-theatre-gold underline hover:text-theatre-gold/80">
              {g.privacy}
            </Link>
          </p>
        </div>
        <div className="flex items-center gap-3 shrink-0">
          <button
            data-testid="consent-refuse"
            onClick={() => choose("refused")}
            className="px-5 py-2.5 text-xs uppercase tracking-[0.18em] border border-white/20 text-neutral-300 hover:border-white/40 transition-colors duration-200"
          >
            {g.refuse}
          </button>
          <button
            data-testid="consent-accept"
            onClick={() => choose("accepted")}
            className="px-6 py-2.5 text-xs uppercase tracking-[0.18em] bg-theatre-red hover:bg-theatre-redhover text-white transition-colors duration-200"
          >
            {g.accept}
          </button>
        </div>
      </div>
    </div>
  );
};
